
import {
  CampaignList,
  GovChart,
  JobChart,
  LandingPage,
  ParticipantsTable,
  QuizAnalysis,
  QuizHome,
  QuizList,
} from "../Compnents/Home";
import { useSelector } from "react-redux";
import { userModel } from "../Interfaces";
import { RootState } from "../Storage/Redux/store";
import { Box, Grid } from "@mui/system";

export default function Home() {
  const userData: userModel = useSelector(
    (state: RootState) => state.userAuthStore
  );

  const isAuthenticated = userData && userData.nameid;

  return (
     <>
    {!isAuthenticated ? (
      <LandingPage />
    ) : userData.role === "Admin" ? (
      <>
        <Grid container justifyContent="center" spacing={3}>
          <Grid size={{md:6,xs:12}}>
            <Box sx={{ mb: 3 }}>
              <CampaignList />
            </Box>
          </Grid>
          <Grid size={{md:6,xs:12}} >
            <Box sx={{ mb: 3 }}>
              <QuizList />
            </Box>
          </Grid>
          <Grid size={{md:6,xs:12}} >
            <Box sx={{ mb: 3 }}>
              <GovChart />
            </Box>
          </Grid>
          <Grid size={{md:6,xs:12}} >
            <Box sx={{ mb: 3 }}>
              <JobChart />
            </Box>
          </Grid>
          
        </Grid>
        <ParticipantsTable />
      </>
    ) : (
      <QuizHome />
    )}
  </>
  );
}
